var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tab-pane fade",class:{'active show': _vm.active},attrs:{"id":_vm.id,"role":"tabpanel","aria-labelledby":_vm.id + '-tab'}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }